import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()

export class RiskEntityMasterService {

    constructor(private http: HttpClient) {

    }

    getEntityList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationTypeList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

    addEntityMaster(entity): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/addEvaluationType', entity)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    updateEntityMaster(updatedEntity): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateEvaluationType' , updatedEntity)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    deleteEntityMaster(entityId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/deleteEvaluationType?evaluationTypeID=' + entityId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }
}